export enum RegistrationTypeEnum {
    DontSend = 0,
    Email = 1,
    SMS = 2,
    Both = 3,
}
